import { render, staticRenderFns } from "./Cinemas.vue?vue&type=template&id=a520ee8e&scoped=true"
import script from "./Cinemas.vue?vue&type=script&lang=js"
export * from "./Cinemas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a520ee8e",
  null
  
)

export default component.exports